import React, { ReactElement, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Select, SelectProps } from "@amzn/awsui-components-react";
import { EditableCellProps } from "../porAsinList/asinListEdit";
import {
  bulkUpdateValidationAttributes,
  updateValidationAttribute,
} from "./asinValidationTableConnector";

const SelectDropdownOptions: Array<SelectProps.Option> = [
  { label: "Pass", value: "pass", iconName: "status-positive" },
  { label: "Fail", value: "fail", iconName: "status-negative" },
  {
    label: "Not Applicable",
    value: "not_applicable",
    iconName: "status-in-progress",
  },
  // This is displayed in cases where no data was provided.
  { label: "No Data", value: "no_data", iconName: "status-stopped" },
];

export type ManualValidationResultAttribute =
  | "validationOverallResultManualDGL"
  | "validationOverallResultManualRL"
  | "validationOverallResultManualInstock"
  | "validationOverallResultManualOX"
  | "validationOverallResultManualGTM"
  | "validationOverallResultManualCS";

export type EditValidationSelectProps = {
  id: ManualValidationResultAttribute;
};

function getDropdownValueFromString(id: string): SelectProps.Option {
  return (
    SelectDropdownOptions.find((item) => item.value === id) ?? {
      label: "No Data",
      value: "no_data",
      iconName: "status-stopped",
    }
  );
}

export const EditSelectDropdown = (
  props: EditValidationSelectProps & EditableCellProps
): ReactElement => {
  const dispatch = useDispatch();
  const itemCurrentValue = props.item
    ? props.item[props.id] ?? "no_data"
    : "no_data";
  const [selectedOption, setSelectedOption] = React.useState(
    getDropdownValueFromString(itemCurrentValue)
  );
  useEffect(() => {
    setSelectedOption(getDropdownValueFromString(itemCurrentValue));
  }, [itemCurrentValue]);

  return (
    <Select
      selectedOption={selectedOption}
      onChange={({ detail }) => {
        if (props.isHeader) {
          dispatch(
            bulkUpdateValidationAttributes([
              props.id,
              detail.selectedOption.value,
            ])
          );
        } else {
          dispatch(
            updateValidationAttribute([
              props.item,
              props.id,
              detail.selectedOption.value,
            ])
          );
        }
        setSelectedOption(detail.selectedOption);
      }}
      options={SelectDropdownOptions.filter(
        (option) => option.value !== "no_data"
      )}
      selectedAriaLabel="Selected"
      expandToViewport={true}
    />
  );
};
